<script setup lang="ts">
import DashboardLayout from '@/onenetwork/layouts/DashboardLayout.vue'
import DataTable from '@/onenetwork/components/datatable/DataTable.vue'
import FilterList from '@/onenetwork/components/filter/FilterList.vue'
import { useRouter } from 'vue-router'
import { computed, onMounted, ref, watch } from 'vue'
import _ from 'lodash'
import AccountDetail from '@/modules/account/views/AccountDetail.vue'
import { BrokerListActionTypes, useBrokerListStore } from '@/modules/broker/stores/broker.list.store.ts'
import BrokerDetail from '@/modules/broker/views/BrokerDetail.vue'
import { useReactiveQueryParam } from '@/composables/useReactiveQueryParam'
import { useBrokerDetailStore } from '../stores/broker.detail.store'


const router = useRouter()
const brokerListStore = useBrokerListStore()
const brokerDetailStore = useBrokerDetailStore()

const pageTabs = computed(() => {
  return brokerListStore.tabs
})
const displayTabContent = computed(() => {
  return brokerListStore.tabs?.find(tab => tab.active)?.id || 'list'
})
const TableConfig = computed(() => {
  return brokerListStore.tableConfig
})
const filter = computed(() => {
  return brokerListStore.filter
})
const loading = computed(() => {
  return brokerListStore.action_type == BrokerListActionTypes.FETCHING
})
const page = computed(() => {
  return brokerListStore.page
})
const pageSize = computed(() => {
  return brokerListStore.pageSize
})
const dataSource = computed(() => {
  return brokerListStore.data
})

const handleChangeTab = (tab: any) => {

  brokerListStore.changeTab(tab.id)
}

const handleCloseTab = (tab: any) => {

  brokerListStore.closeTab(tab.id)
}

const handleCloseAllTab = () => {
  brokerListStore.closeAllTab()
}

const handleChangePage = (page: number) => {

  brokerListStore.changePage(page)
}

const handleChangePageSize = (size: number) => {

  brokerListStore.changePageSize(size)
}

const handleUpdateFilter = (filter: any) => {

  brokerListStore.setFilter(filter)
}

const handleRowDblClick = (e: MouseEvent, item: any) => {

  brokerListStore.newTab({id: item.id, label: `#${item.code} - ${item.full_name}`, active: true})
}

const handleRowClick = (e: MouseEvent, item: any) => {

}

const handleChangeSelectedRow = (ids: Array<string|number>) => {

}

const handleSort = (field: string, direction: string) => {

  brokerListStore.toggleSort(field, direction)
}

const requestFetchAccountList = _.debounce(async () => {
  try{
    const res = await brokerListStore.fetchList()
  } catch (e) {

  }
}, 500)

const detailId: any = useReactiveQueryParam('detailId')
const setDetailTab = async () => {
  if(parseInt(detailId.value || 0)){
    try {
      const data: any = await brokerDetailStore.fetchBrokerDetail(parseInt(detailId.value))
      console.log('dataxxxx', data)
      brokerListStore.newTab({id: data?.id, label: `#${data?.user?.code} - ${data?.user?.full_name}`, active: true})
    } catch (e: any) {
      console.log(e)
    }
  }
}

watch(()=>detailId, (val) => {
  console.log('Giá trị detailId thay đổi:', val.value)
  if(val.value) setDetailTab()
}, {immediate: true})


watch(()=> brokerListStore.uuid, (newVal, oldVal) => {
  requestFetchAccountList()
})

onMounted(() => {
  brokerListStore.changeTab('list')
  // if(brokerListStore.action_type === BrokerListActionTypes.PENDING) requestFetchAccountList()
  requestFetchAccountList()
})
</script>

<template>
  <dashboard-layout currentRoute="broker/list" page-title="Quản lý môi giới" :tabs="pageTabs" :tabsEvent="{
    close: handleCloseTab,
    select: handleChangeTab,
    closeAll: handleCloseAllTab
  }">
    <template v-if="displayTabContent == 'list'">
      <filter-list
        :filter="filter"
        @update:filter="handleUpdateFilter"
        @reset:filter="brokerListStore.resetFilter"
      />
      <data-table
        :loading="loading"
        :tableConfig="TableConfig"
        :page-size="pageSize"
        :page="page"
        :total-page="dataSource?.totalPage || 0"
        :total-records="dataSource?.totalRecords || 0"
        :data="dataSource?.list || []"
        :row-action-buttons="[
          { action: handleRowDblClick, css: 'btn btn-cs', label: 'Chi tiết', icon: 'iconamoon:edit-duotone', perm: 'broker.view_info' }
        ]"
        primaryField=""
        @page-changed="handleChangePage"
        @pagesize-changed="handleChangePageSize"
        @toggle-visibility="brokerListStore.toggleColumnVisibility"
        @on-selected-row="handleChangeSelectedRow"
        @on-sort="handleSort"
      />
    </template>
    <template v-else>
      <template v-for="tab in pageTabs">
        <template v-if="tab.id == displayTabContent">
          <BrokerDetail :id="tab.id" :key="tab.id" :is-update="true"/>
        </template>
      </template>
    </template>
  </dashboard-layout>
</template>

<style scoped></style>
